import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import SocialsHero from "../components/organisms/SocialsHero"
import CompanyAddress from "../components/organisms/CompanyAddress"
import SectionImage from "../components/molecules/SectionImage"

const query = graphql`
  {
    allStrapiAdchitectsSocials {
      nodes {
        socialLink
        socialName
      }
    }
    strapiContact {
      plAddress {
        addressInfo
        addressTitle
        dunsNumber
        euVatID
      }
      usaAddress {
        addressInfo
        addressTitle
        jurisdictionOfFormation
        registrationNumber
      }
      header {
        subtitle
        title
      }
      image {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageMobile {
        childImageSharp {
          fluid(maxWidth: 540, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      underHeaderDescription
      metaTags {
        description
        ogImage {
          childImageSharp {
            fluid(maxWidth: 1200, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        title
      }
    }
    strapiOptions {
      clutchReview
      numberOfReviews
    }
  }
`

const IndexPage = () => {
  const data = useStaticQuery(query)
  const header = data.strapiContact.header
  const socials = data.allStrapiAdchitectsSocials.nodes
  const image = data.strapiContact.image.childImageSharp.fluid
  const imageMobile = data.strapiContact.imageMobile.childImageSharp.fluid
  const usaAddress = data.strapiContact.usaAddress
  const plAddress = data.strapiContact.plAddress
  const seo = data.strapiContact.metaTags
  const clutchRating = data.strapiOptions.clutchReview
  const numberOfReviews = data.strapiOptions.numberOfReviews

  return (
    <Layout className="contact">
      <SEO
        image={seo.ogImage.childImageSharp.fluid.src}
        title={seo.title}
        description={seo.description}
      />
      <SocialsHero
        url={`mailto:${header.title}`}
        socials={socials}
        subtitle={header.subtitle}
        clutchRating={clutchRating}
        numberOfReviews={numberOfReviews}
      >
        {header.title}
      </SocialsHero>
      <CompanyAddress usaAddress={usaAddress} plAddress={plAddress} />
      <div className="section section--image">
        <div className="wrapper">
          <SectionImage
            alt="The brick wall at the software house company's office"
            mobileImage={imageMobile}
            image={image}
          />
        </div>
      </div>
    </Layout>
  )
}
export default IndexPage
